import React from 'react';
import { CustomersEvidenceFiltersContextProvider } from './CustomersEvidenceFiltersContext';

/**
 * Wrapper component that provides CustomersEvidenceFiltersContext for Customer360
 * This ensures that filter changes are reflected in evidenceFilters from SingleCustomerContext
 */
const CustomerFiltersContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <CustomersEvidenceFiltersContextProvider>
      {children}
    </CustomersEvidenceFiltersContextProvider>
  );
};

export default CustomerFiltersContextProvider;

